import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_7 = { class: "table-responsive" };
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = {
    colspan: "5",
    class: "text-center py-4"
};
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_12 = {
    class: "shadow-none lh-1 fw-medium text-black-emphasis text-wrap",
    style: { "max-width": "300px" }
};
const _hoisted_13 = {
    class: "shadow-none lh-1 fw-medium text-muted text-wrap",
    style: { "max-width": "400px" }
};
const _hoisted_14 = { class: "form-check form-switch" };
const _hoisted_15 = ["checked", "onChange"];
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-end pe-0" };
const _hoisted_17 = { class: "dropdown" };
const _hoisted_18 = { class: "dropdown-menu" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = { key: 2 };
const _hoisted_22 = {
    class: "modal fade",
    id: "faqModal",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_23 = { class: "modal-dialog modal-dialog-centered modal-lg" };
const _hoisted_24 = { class: "modal-content border-0 rounded-1" };
const _hoisted_25 = { class: "modal-header" };
const _hoisted_26 = { class: "modal-title fw-bold" };
const _hoisted_27 = { class: "modal-body p-20" };
const _hoisted_28 = {
    class: "nav nav-tabs mb-4 border-0 bg-light p-1 rounded-1",
    role: "tablist"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = { class: "row g-3" };
const _hoisted_31 = { class: "form-label fw-semibold" };
const _hoisted_32 = ["onUpdate:modelValue", "required"];
const _hoisted_33 = { class: "form-label fw-semibold" };
const _hoisted_34 = ["onUpdate:modelValue", "required"];
const _hoisted_35 = { class: "col-12 border-top mt-4 pt-3" };
const _hoisted_36 = { class: "row" };
const _hoisted_37 = { class: "col-md-6" };
const _hoisted_38 = { class: "col-md-6 d-flex align-items-end" };
const _hoisted_39 = { class: "form-check form-switch mb-2" };
const _hoisted_40 = { class: "text-end mt-4" };
const _hoisted_41 = ["disabled"];
const _hoisted_42 = {
    key: 0,
    class: "fas fa-spinner fa-spin me-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.openAddModal && _ctx.openAddModal(...args))),
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button"
                }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.add')) + " FAQ ", 1),
                    _cache[6] || (_cache[6] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                ])
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("form", {
                    class: "search-box position-relative me-15",
                    onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => { }, ["prevent"]))
                }, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchQuery) = $event)),
                        type: "text",
                        class: "form-control shadow-none text-black rounded-0 border-0",
                        placeholder: _ctx.$t('common.search')
                    }, null, 8, _hoisted_5), [
                        [_vModelText, _ctx.searchQuery]
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("button", {
                        type: "submit",
                        class: "bg-transparent text-primary transition p-0 border-0"
                    }, [
                        _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                    ], -1))
                ], 32)
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                    _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Ordre"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Question (FR)"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Réponse (FR)"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                            }, "Statut"),
                            _createElementVNode("th", {
                                scope: "col",
                                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
                            }, "Actions")
                        ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                        (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                                _createElementVNode("td", _hoisted_10, [
                                    _createVNode(_component_LoaderComponent)
                                ])
                            ]))
                            : (_ctx.filteredFaqs.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredFaqs, (faq) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: faq.id
                                    }, [
                                        _createElementVNode("td", _hoisted_11, _toDisplayString(faq.order), 1),
                                        _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.getTranslatedContent(faq.question)), 1),
                                        _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.truncateText(_ctx.getTranslatedContent(faq.answer), 100)), 1),
                                        _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_14, [
                                                _createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    checked: faq.isActive,
                                                    onChange: ($event) => (_ctx.toggleStatus(faq))
                                                }, null, 40, _hoisted_15)
                                            ])
                                        ]),
                                        _createElementVNode("td", _hoisted_16, [
                                            _createElementVNode("div", _hoisted_17, [
                                                _cache[10] || (_cache[10] = _createElementVNode("button", {
                                                    class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                    type: "button",
                                                    "data-bs-toggle": "dropdown"
                                                }, [
                                                    _createElementVNode("i", { class: "flaticon-dots" })
                                                ], -1)),
                                                _createElementVNode("ul", _hoisted_18, [
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item d-flex align-items-center",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.editFaq(faq))
                                                        }, [...(_cache[8] || (_cache[8] = [
                                                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8" }, null, -1),
                                                                _createTextVNode(" Modifier ", -1)
                                                            ]))], 8, _hoisted_19)
                                                    ]),
                                                    _createElementVNode("li", null, [
                                                        _createElementVNode("a", {
                                                            class: "dropdown-item d-flex align-items-center text-danger",
                                                            href: "javascript:void(0);",
                                                            onClick: ($event) => (_ctx.confirmDelete(faq))
                                                        }, [...(_cache[9] || (_cache[9] = [
                                                                _createElementVNode("i", { class: "flaticon-delete lh-1 me-8" }, null, -1),
                                                                _createTextVNode(" Supprimer ", -1)
                                                            ]))], 8, _hoisted_20)
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ]));
                                }), 128))
                                : (_openBlock(), _createElementBlock("tr", _hoisted_21, [...(_cache[11] || (_cache[11] = [
                                        _createElementVNode("td", {
                                            colspan: "5",
                                            class: "text-center py-4 text-muted"
                                        }, "Aucune FAQ trouvée.", -1)
                                    ]))]))
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("h5", _hoisted_26, _toDisplayString(_ctx.isEditing ? 'Modifier la FAQ' : 'Ajouter une FAQ'), 1),
                        _cache[13] || (_cache[13] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close shadow-none",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("ul", _hoisted_28, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLangs, (lang) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    class: "nav-item",
                                    key: lang.code
                                }, [
                                    _createElementVNode("button", {
                                        class: _normalizeClass(["nav-link border-0 text-uppercase fw-bold py-2 px-3 rounded-1 transition shadow-none", { 'active bg-white text-primary shadow-sm': _ctx.activeLocale === lang.code, 'text-muted': _ctx.activeLocale !== lang.code }]),
                                        onClick: ($event) => (_ctx.activeLocale = lang.code),
                                        type: "button"
                                    }, _toDisplayString(lang.label), 11, _hoisted_29)
                                ]));
                            }), 128))
                        ]),
                        _createElementVNode("form", {
                            onSubmit: _cache[5] || (_cache[5] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.saveFaq && _ctx.saveFaq(...args)), ["prevent"]))
                        }, [
                            _createElementVNode("div", _hoisted_30, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLangs, (lang) => {
                                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                                        class: "col-12",
                                        key: 'q-' + lang.code
                                    }, [
                                        _createElementVNode("label", _hoisted_31, "Question (" + _toDisplayString(lang.label) + ")", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control shadow-none rounded-0 border-light-subtle",
                                            "onUpdate:modelValue": ($event) => ((_ctx.form.question[lang.code]) = $event),
                                            required: lang.code === 'fr'
                                        }, null, 8, _hoisted_32), [
                                            [_vModelText, _ctx.form.question[lang.code]]
                                        ])
                                    ])), [
                                        [_vShow, _ctx.activeLocale === lang.code]
                                    ]);
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLangs, (lang) => {
                                    return _withDirectives((_openBlock(), _createElementBlock("div", {
                                        class: "col-12",
                                        key: 'a-' + lang.code
                                    }, [
                                        _createElementVNode("label", _hoisted_33, "Réponse (" + _toDisplayString(lang.label) + ")", 1),
                                        _withDirectives(_createElementVNode("textarea", {
                                            class: "form-control shadow-none rounded-0 border-light-subtle",
                                            rows: "5",
                                            "onUpdate:modelValue": ($event) => ((_ctx.form.answer[lang.code]) = $event),
                                            required: lang.code === 'fr'
                                        }, null, 8, _hoisted_34), [
                                            [_vModelText, _ctx.form.answer[lang.code]]
                                        ])
                                    ])), [
                                        [_vShow, _ctx.activeLocale === lang.code]
                                    ]);
                                }), 128)),
                                _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                            _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Ordre d'affichage", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "number",
                                                class: "form-control shadow-none rounded-0",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.form.order) = $event))
                                            }, null, 512), [
                                                [
                                                    _vModelText,
                                                    _ctx.form.order,
                                                    void 0,
                                                    { number: true }
                                                ]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_38, [
                                            _createElementVNode("div", _hoisted_39, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input ms-0",
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.form.isActive) = $event)),
                                                    id: "modalActive"
                                                }, null, 512), [
                                                    [_vModelCheckbox, _ctx.form.isActive]
                                                ]),
                                                _cache[15] || (_cache[15] = _createElementVNode("label", {
                                                    class: "form-check-label ms-2",
                                                    for: "modalActive"
                                                }, "Activé", -1))
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                                _cache[17] || (_cache[17] = _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-secondary me-2 rounded-0",
                                    "data-bs-dismiss": "modal"
                                }, "Annuler", -1)),
                                _createElementVNode("button", {
                                    type: "submit",
                                    class: "btn btn-primary rounded-0 px-4",
                                    disabled: _ctx.isSaving
                                }, [
                                    (_ctx.isSaving)
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_42))
                                        : _createCommentVNode("", true),
                                    _cache[16] || (_cache[16] = _createTextVNode(" Enregistrer ", -1))
                                ], 8, _hoisted_41)
                            ])
                        ], 32)
                    ])
                ])
            ])
        ])
    ]));
}
